import { Fragment } from 'react'
import { DictionaryComponents } from '../../../../utils/globals/types'
import OrderEditProduct from '../OrderLayout/OrderTable/TableComponents/OrderEditProduct'
import InputTableLayout, { BigTitleAndRightLayoutInputTableSupplier, InputTableLayoutNew, InputTableLayoutProps } from '../../../../baseComponents/TwinTable/InputTableLayout'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../utils/reducers'
import { ITDisplayPrice, ITDisplayFinalPrice, ITDisplayEditFinalPrice, ITDisplayImage, ITBooleanRender, ITDisplayPriceNotRounded, ITDisplayEditFinalPriceBase, ITDeleteRowBuy } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { InputTableFooterFullProps } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { ITOrderBooleanRectangle, OrderCustomSelectBlockedItemsSearchbar, OrderEditableName, OrderEditableText, OrderInputCalendar, OrderInputDiscount, OrderInputPercentage, OrderInputPrice, OrderInputQuantity, OrderInputQuantity2, OrderRectangularInputSmall, OrderSaveRemainingProduct } from '../OrderLayout/OrderTable/TableComponents/Inputs'
import OrderSearchProductInput, { OrderSearchProductInputCreate, OrderSearchProductInputName, OrderSearchProductInputReferenceAndName } from '../OrderLayout/OrderTable/TableComponents/Inputs/OrderSearchProductInput'
import OrderEditBuyAddonProduct from '../OrderLayout/OrderTable/TableComponents/OrderEditBuyAddonProduct'
import { ITInputSelectAccounts, ITInputSelect } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Inputs'
import { OrderDragHandle } from '../OrderLayout/OrderTable/TableComponents/Sorts'
import OrderTotal, { OrderTotalNew } from '../OrderLayout/OrderTotal'
import { getCostsBuy } from '../../../../utils/reducers/getters'
import ModalsOrderBuyLayout from './ModalsOrderBuyLayout'
import OrderUniqueNumberProduct, { OrderUniqueNumberProductReadOnly } from '../OrderLayout/OrderTable/TableComponents/OrderUniqueNumberProduct'
import { OrderSearchSupplierProductInputName, OrderSearchSupplierProductInputReference, OrderSearchSupplierProductInputReferenceAndName } from './Inputs'
import { CostBuyPayload } from '../../../../utils/reducers/company/costsBuy'
import { useOrderLayoutTableLogic } from '../OrderLayout/OrderTable/useOrderLayoutTableLogic'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { BuySelectedCheckbox } from '../../../buys/components'
import OrderPrintTags from '../OrderLayout/OrderTable/TableComponents/OrderPrintTags'
import AppStyleDecider from '../../../../baseComponents/AppsStyleDecider'
import { FooterRowBuyShortComponent } from '../OrderLayout/OrderTable/TableComponents/OrderTotal/Components/HeaderOrderTotal'
import { FooterConfigBuyShippingComponent } from '../OrderLayout/OrderTotal/FooterOrderTotal/Components/FooterOrderLeftComponent'
import useOrderCalculateTotals from '../../../../utils/hooks/orders/useOrderCalculateTotals'

interface OrderBuyLayoutProps extends InputTableLayoutProps {
    orderStatusDict: TwinDictionary
}

const OrderBuyLayout: React.FC<OrderBuyLayoutProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={InputTableLayoutRenderDefault} NewComponent={InputTableLayoutRenderNew} {...rest} />
    )
}

const InputTableLayoutRenderDefault: React.FC<OrderBuyLayoutProps> = ({ ...rest }) => {
    return (
        <InputTableLayout hookFunction={useOrderLayoutTableLogic} TableChildren={OrderTableChildren} {...rest} components={components} BigAndTitleRightLayout={BigTitleAndRightLayoutInputTableSupplier} />
    )
}

const InputTableLayoutRenderNew: React.FC<OrderBuyLayoutProps> = ({ ...rest }) => {
    return (
        <InputTableLayoutNew hookFunction={useOrderLayoutTableLogic} TableChildren={OrderTableChildrenNew} {...rest} components={components} BigAndTitleRightLayout={BigTitleAndRightLayoutInputTableSupplier} />
    )
}

const OrderTableChildren: React.FC<InputTableFooterFullProps> = ({ completeData, CurrencyId, eventFunctions, customParseTableData, ...rest }) => {
    const costs = getCostsBuy()
    const { totalsOrderTableData } = useOrderCalculateTotals({ completeData, customParseTableData })
    return (
        <Fragment>
            {!completeData?.header?.hidePrices ? <OrderTotal costs={costs || {}} {...{ completeData, CurrencyId, skipEdit: true, totalsOrderTableData, ...rest }}/> : null}
            <ModalsOrderBuyLayout headerData={completeData.header} deleteLine={eventFunctions.deleteLine} onChangeAdd={eventFunctions.onChangeAdd} onChangeFetch={eventFunctions.onChangeFetch} onChangeUpdate={eventFunctions.onChangeUpdate} completeData={completeData} {...rest} />
        </Fragment>
    )
}

const OrderTableChildrenNew: React.FC<InputTableFooterFullProps> = ({ completeData, CurrencyId, eventFunctions, customParseTableData, ...rest }) => {
    const costs = getCostsBuy()
    const { totalsOrderTableData } = useOrderCalculateTotals({ completeData, customParseTableData })
    return (
        <Fragment>
            {!completeData?.header?.hidePrices ? <OrderTotalNew costs={costs || {}} FooterOrderRowShortComponent={FooterRowBuyShortComponent} FooterOrderLeftConfigComponent={FooterConfigBuyShippingComponent} {...{ completeData, CurrencyId, skipEdit: true, totalsOrderTableData, ...rest }} /> : null}
            <ModalsOrderBuyLayout headerData={completeData.header} deleteLine={eventFunctions.deleteLine} onChangeAdd={eventFunctions.onChangeAdd} onChangeFetch={eventFunctions.onChangeFetch} onChangeUpdate={eventFunctions.onChangeUpdate} completeData={completeData} {...rest} />
        </Fragment>
    )
}

const components: DictionaryComponents = {
    ITRectangularInput: OrderRectangularInputSmall,
    ITEditableText: OrderEditableText,
    ITEditableName: OrderEditableName,
    ITInputNumeric: OrderInputPrice,
    ITInputPercentage: OrderInputPercentage,
    OrderSearchProductInput: OrderSearchProductInput,
    OrderSearchProductInputName: OrderSearchProductInputName,
    OrderSearchProductInputReferenceAndName: OrderSearchProductInputReferenceAndName,
    OrderSearchProductInputCreate: OrderSearchProductInputCreate,
    OrderSearchSupplierProductInputReference: OrderSearchSupplierProductInputReference,
    OrderSearchSupplierProductInputReferenceAndName: OrderSearchSupplierProductInputReferenceAndName,
    OrderSearchSupplierProductInputName: OrderSearchSupplierProductInputName,
    OrderSaveRemainingProduct: OrderSaveRemainingProduct,
    ITOrderBooleanRectangle: ITOrderBooleanRectangle,
    OrderUniqueNumberProduct: OrderUniqueNumberProduct,
    OrderUniqueNumberProductReadOnly: OrderUniqueNumberProductReadOnly,
    ITSelectSpecificPriceRule: OrderCustomSelectBlockedItemsSearchbar,
    ITInputQuantity: OrderInputQuantity,
    ITInputQuantity2: OrderInputQuantity2,
    ITInputDiscount: OrderInputDiscount,
    ITInputCalendar: OrderInputCalendar,
    ITDragHandle: OrderDragHandle,
    ITDisplayPrice: ITDisplayPrice,
    ITInputPrice: OrderInputPrice,
    ITDisplayPriceNotRounded: ITDisplayPriceNotRounded,
    ITDisplayFinalPrice: ITDisplayFinalPrice,
    ITDisplayEditFinalPrice: ITDisplayEditFinalPrice,
    ITDisplayEditFinalPriceBase: ITDisplayEditFinalPriceBase,
    OrderEditProduct: OrderEditProduct,
    OrderEditAddonProduct: OrderEditBuyAddonProduct,
    OrderPrintTags,
    ITDisplayImage: ITDisplayImage,
    ITBooleanRender: ITBooleanRender,
    ITInputSelectAccounts: ITInputSelectAccounts,
    ITInputSelect: ITInputSelect,
    CheckboxComponent: BuySelectedCheckbox,
    DeleteComponent: ITDeleteRowBuy
}

const orderBuyLayoutDispatch = {
    setCostsBuy: (payload: CostBuyPayload) => ({ type: 'CHANGE_COSTSBUY', payload }),
}

export type ReduxOrderBuyLayout = ConnectedProps<typeof orderBuyLayoutConnect>
const mapOrderBuyLayoutConnector = (state: AllReduxPayloads) => ({ costsBuy: state.costsBuy })
const orderBuyLayoutConnect = connect(mapOrderBuyLayoutConnector, orderBuyLayoutDispatch)
const orderBuyLayoutConnectLoading = withLoading(OrderBuyLayout, [{ fetchUrl: '/api/app/config/cost/costBuy/getAllCostBuys', propName: 'costsBuy', setFunctionName: 'setCostsBuy' }])
const OrderBuyLayoutConnect = orderBuyLayoutConnect(orderBuyLayoutConnectLoading)


export default OrderBuyLayoutConnect